import { useBoolean } from '@dreryk/react-common';

import { CustomPatientGroupsUpdateModal } from './CustomPatientGroupsUpdateModal';

type CustomPatientGroupsUpdateModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type CustomPatientGroupsUpdateModalOpenerProps = {
   children: (renderProps: CustomPatientGroupsUpdateModalOpenerRenderProps) => JSX.Element;
   patientGroupId: number;
};

export const CustomPatientGroupsUpdateModalOpener = (props: CustomPatientGroupsUpdateModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <CustomPatientGroupsUpdateModal patientGroupId={props.patientGroupId} onClose={closeModal} />
         ) : null}
      </>
   );
};
